'use client';

import { AppRoute } from '../../enums/enums';
import { Button } from '../button/button';
import OraganogenesisLogo from '../../../../public/svg/ogn-logo.svg';
import { HealthcareButton, MobileNavigation } from './components';
import { cn } from '@shared/shared-utils';
import ArrowRightIcon from '../../../../public/svg/arrow-right.svg';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { Tooltip } from '../tooltip/tooltip';

const Header = () => {
  const pathname = usePathname();

  const isFindAProfessionalPage = pathname === AppRoute.FIND_A_PROFESSIONAL;
  const isMainPage = pathname === AppRoute.MAIN;

  return (
    <header
      className={cn(
        'sticky top-0 z-40 bg-ogn-blue lg:px-12 lg:py-3 w-full lg:hover:bg-ogn-bright-yellow transition-colors duration-500 group overflow-visible',
        {
          'lg:hidden': isFindAProfessionalPage,
          'lg:py-[unset] 2xl:py-4 lg:px-[unset] 2xl:px-12': isMainPage,
        },
      )}
    >
      {!isFindAProfessionalPage && (
        <div
          className={cn(
            'flex relative items-center justify-center w-full gap-x-4',
            {
              'lg:py-3 2xl:py-[unset]': isMainPage,
            },
          )}
        >
          <Link
            className={cn(
              'lg:inline-flex lg:absolute hidden mt-2 lg:left-0 self-start shrink-0',
              {
                'lg:hidden 2xl:inline-flex py-[unset] lg:py-3 2xl:py-0':
                  isMainPage,
              },
            )}
            href={AppRoute.MAIN}
            aria-label="Main Page Link"
          >
            <OraganogenesisLogo
              className={cn(
                'lg:block hidden w-[min(17vw,343px)] h-[31px] text-ogn-bright-yellow group-hover:text-ogn-blue transition-colors duration-500',
                {
                  'lg:hidden 2xl:block': isMainPage,
                },
              )}
              aria-hidden="true"
              focusable="false"
            />
          </Link>
          <div className="lg:p-0 py-4 flex items-center justify-center gap-x-[6px] lg:justify-between w-full lg:w-auto lg:gap-x-4">
            <span className="text-[13px] text-nowrap lg:text-[min(1.9vw,24px)] text-ogn-bright-yellow font-bold lg:group-hover:text-ogn-blue transition-colors duration-500 font-roboto-condensed">
              Your wounds won’t wait.
            </span>
            <Tooltip content="Find a healthcare professional now">
              <Button
                className="!hover:after:bg-ogn-blue px-2 md:px-3 font-roboto-condensed flex items-center gap-x-1 md:gap-x-2 text-nowrap w-auto max-w-[calc(100vw-2rem)] lg:w-auto lg:text-[min(1.9vw,24px)] text-[12px] md:text-[13px] rounded-full overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-ogn-blue focus-visible:ring-offset-2 focus-visible:ring-offset-transparent"
                variant="white"
                to={AppRoute.FIND_A_PROFESSIONAL}
                aria-label="Find a healthcare professional now"
              >
                Find a Healthcare Professional Now{' '}
                <ArrowRightIcon
                  className="w-[10px] h-[10px] md:w-[12px] md:h-[12px] lg:w-[16px] lg:h-[16px]"
                  aria-hidden="true"
                  focusable="false"
                />
              </Button>
            </Tooltip>
          </div>
          <HealthcareButton isMainPage={isMainPage} />
        </div>
      )}
      <MobileNavigation isMainPage={isMainPage} />
    </header>
  );
};

export { Header };
